// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useEffect, useMemo, useState } from 'react'
import './AllergiesHoverOverPopUp.scss'
import { AllergiesHoverOverPopUpItem } from './AllergiesHoverOverPopUpItem/AllergiesHoverOverPopUpItem'
import { text } from '../../pages/charts/Constants'

const UNKNOWN_AUTHOR = 'Author unknown'

/**
 * The author line for one allergy.
 *
 * The guard is `Author &&` and not `Author?.UserType !== 'patient'`: the latter is *true*
 * for a missing author — `undefined !== 'patient'` — so it took the clinician branch and
 * threw reading `Author.Prefix`. A missing author is also not the same claim as a
 * patient-reported one, so it must not fall through to "Self-reported" either.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getAuthorLabel = (Author) => {
  if (!Author) return UNKNOWN_AUTHOR
  if (Author.UserType === 'patient') return text.SELF_REPORTED
  const prefix = Author.Prefix ? `${Author.Prefix} ` : ''
  const suffix = Author.Suffix ? ` ${Author.Suffix}` : ''
  const name = [Author.FirstName, Author.LastName].filter(Boolean).join(' ')
  if (!name) return UNKNOWN_AUTHOR
  return `${prefix}${name}${suffix}`
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const AllergiesHoverOverPopUp = memo(({ patientInfo, containerStyle }) => {
  // Distinguish "the chart says there are none" from "we have no allergy data". A missing
  // AllergyCollection is the second, and rendering the empty state for it would put an
  // affirmative clinical negative — "No allergies have been added to this patient's chart"
  // — in front of a clinician on the strength of data that never arrived.
  const hasAllergyData = Boolean(patientInfo?.AllergyCollection?.Allergies)
  const allergiesList = useMemo(
    () => patientInfo?.AllergyCollection?.Allergies || [],
    [patientInfo?.AllergyCollection?.Allergies],
  )

  const [orderedAllergiesList, setOrderedAllergiesList] = useState([])

  useEffect(() => {
    setOrderedAllergiesList(allergiesList)
  }, [allergiesList])

  if (!hasAllergyData) {
    return (
      <div className='allergies-hover-over-pop-up-container' style={containerStyle}>
        <div className='allergies-hover-over-pop-up-item-empty'>
          <div className='allergies-hover-over-pop-up-item-title'>Allergies unavailable</div>
          <div className='allergies-hover-over-pop-up-item-body'>
            This patient’s allergy list could not be loaded. Reload the chart before relying on it.
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='allergies-hover-over-pop-up-container' style={containerStyle}>
      {orderedAllergiesList?.length ?
        orderedAllergiesList.map(({ Name, Severity, AllergyId, Author }, i) => (
          <AllergiesHoverOverPopUpItem
            key={AllergyId}
            Name={Name}
            Severity={Severity}
            ItemId={AllergyId}
            isLastItem={i === orderedAllergiesList.length - 1}
            author={getAuthorLabel(Author)}
          />
        ))
      : <div className='allergies-hover-over-pop-up-item-empty'>
          <div className='allergies-hover-over-pop-up-item-title'>No allergy on chart</div>
          <div className='allergies-hover-over-pop-up-item-body'>
            No allergies have been added to this patient’s chart.
          </div>
        </div>
      }
    </div>
  )
})
